import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastModule } from 'primeng/toast';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterOutlet ,ToastModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'Zatca';

  constructor(_TranslateService: TranslateService) {
    // this language will be used as a fallback when a translation isn't found in the current language
    _TranslateService.setDefaultLang('ar');

    // the lang to use, if the lang isn't available, it will use the current loader to get them
    _TranslateService.use('ar');
  }
}
